export class MapLocation {
  address?: string;

  latitude?: number;

  longitude?: number;
}
